/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import {
  RadioGroup,
  Radio,
  Button,
  FormControlLabel,
  MenuItem,
  Select,
  setRef
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import {
  getAccountInfoData,
  modifyDistribution,
  createDistribution,
  createModifyGroup,
  getGroupListData
} from "../modules/Auth/_redux/adminCrud";
import { SelectUser } from "./SelectUser";
import { toast } from "react-toastify";

const formatBytes = (bytes = 0, fixed) => {
  const marker = 1024; // Change to 1000 if required
  const decimal = fixed != null ? fixed : 2; // Change as required
  const kiloBytes = marker; // One Kilobyte is 1024 bytes
  const megaBytes = marker * marker; // One MB is 1024 KB
  const gigaBytes = marker * marker * marker; // One GB is 1024 MB
  // const teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

  // return bytes if less than a KB
  if (bytes == null || bytes < kiloBytes) {
    return `${bytes}B`;
    // return KB if less than a MB
  }
  if (bytes < megaBytes) {
    return `${(bytes / kiloBytes).toFixed(decimal)}KB`;
    // return MB if less than a GB
  }
  if (bytes < gigaBytes) {
    return `${(bytes / megaBytes).toFixed(decimal)}MB`;
    // return GB if less than a TB
  }

  return `${(bytes / gigaBytes).toFixed(decimal)}GB`;
};

export function GroupEdit(data,groupCode, groupLevel, parentGroupCode) {
  const useStyles = makeStyles(theme => ({
    popLabelStyle: {
      display: "inline-block",
      //   marginTop: "-2px",
      textAlign: "left",
      fontSize: "1rem",
      width: "136px",
      height: "34px"
      //   borderRight: "1px solid #c8cace"
    },
    popInputSmallStyle: {
      display: "inline-block",
      marginLeft: "8px",
      paddingLeft: "8px",
      fontSize: "1rem",
      width: "80px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    popInputStyle: {
      display: "inline-block",
      marginTop: "-2px",
      paddingLeft: "8px",
      fontSize: "1rem",
      width: "80px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    popInputLongStyle: {
      display: "inline-block",
      marginTop: "-2px",
      paddingLeft: "8px",
      fontSize: "1rem",
      width: "300px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    labelStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1rem",
      width: "160px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "24px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    selectStyle: {
      display: "inline-flex",
      width: "200px",
      height: "24px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      background: "transparent",
      marginRight: "12px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        background: "transparent"
      }
    },
    treeContainerStyle: {
      display: "inline-block",
      width: "calc(20% - 12px)",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px",
      marginRight: "12px",
      verticalAlign: "top"
    },
    listContainerStyle: {
      display: "inline-block",
      width: "80%",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "2px 2px 2px 2px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid #c8cace",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid #c8cace",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleInnerStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      margin: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },

    subTitleLastStyle: {
      fontSize: "1rem",
      //   fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    subTitlePopStyle: {
      fontSize: "1rem",
      color: "#555555",
      margin: "4px"
    },
    subTitlePopLineStyle: {
      fontSize: "1rem",
      color: "#555555",
      margin: "4px",
      height: "32px"
      //   borderBottom: "1px solid #c8cace"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      fontWeight: "bold",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid #c8cace"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);

  const [groupName, setGroupName] = React.useState("");
  const [groupEmail, setGroupEmail] = React.useState("");
  // const [groupEmailNew, setGroupEmailNew] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [hasEmail, setHasEmail] = React.useState(false);

  const [showOrgList, setShowOrgList] = React.useState(false);
  const [tempDeptName, setTempDeptName] = React.useState("");
  const [deptName, setDeptName] = React.useState("");

  const [zimbraMailQuota, setZimbraMailQuota] = React.useState(0);
  const [
    zimbraMailAttachmentMaxSize,
    setZimbraMailAttachmentMaxSize
  ] = React.useState(0);

  const [enableMailQuota, setEnableMailQuota] = React.useState("FALSE");
  const [enableMaxSendAttachSize, setEnableMaxSendAttachSize] = React.useState(
    "FALSE"
  );
  const [
    enableMaxSendAttachCount,
    setEnableMaxSendAttachCount
  ] = React.useState("FALSE");

  const [
    zimbraFeatureAdminPreferencesEnabled,
    setZimbraFeatureAdminPreferencesEnabled
  ] = React.useState("FALSE");
  const [zimbraAccountStatus, setZimbraAccountStatus] = React.useState(
    "active"
  );
  const [quotaType, setQuotaType] = React.useState("G");
  const [createTime, setCreateTime] = React.useState("");
  const [lastLogonTime, setLastLogonTime] = React.useState("");
  const [groupList, setGroupList] = React.useState([1, 3]);
  const [memberList, setMemberList] = React.useState([]);
  const [deletedList, setDeletedList] = React.useState([]);

  
  const [tempPassword, setTempPassword] = React.useState("");
  const [tempPassword1, setTempPassword1] = React.useState("");
  const [showChangePassword, setShowChangePassword] = React.useState(false);

  const [enableFileQuota, setEnableFileQuota] = React.useState("FALSE");
  const [enableMaxRecvSize, setEnableMaxRecvSize] = React.useState("FALSE");
  const [enableMaxSendSize, setEnableMaxSendSize] = React.useState("FALSE");

  const handlePressDeleteGroup = index => {
    groupList.splice(index, 1);
    setGroupList(groupList);
    setRefresh(!refresh);
  };
  const handleChangeMailQuota = event => {
    setEnableMailQuota(event.target.value);
  };
  const handleChangeFileQuota = event => {
    setEnableFileQuota(event.target.value);
  };
  const handleChangeMaxRecvSize = event => {
    setEnableMaxRecvSize(event.target.value);
  };
  const handleChangeMaxSendSize = event => {
    setEnableMaxSendSize(event.target.value);
  };
  const handleChangeMaxSendAttachSize = event => {
    setEnableMaxSendAttachSize(event.target.value);
  };
  const handleChangeMaxSendAttachCount = event => {
    setEnableMaxSendAttachCount(event.target.value);
  };
  const handleChangeLevel = event => {
    setZimbraFeatureAdminPreferencesEnabled(event.target.value);
  };

  const handleChangeStatus = event => {
    setZimbraAccountStatus(event.target.value);
  };

  const handleChangeUsage = event => {
    setQuotaType(event.target.value);
    setRefresh(!refresh);
  };

  const getAccountInfo = emailId => {
    setGroupName(data.userData.dlName || "");
    setGroupEmail(data.userData.dlEmail);
    // setTempDeptName(data.userData.teamName);
    // setDeptName(data.userData.teamName);

    getAccountInfoData(emailId).then(data => {
      if (data.data.accountInfo != null) {
        const accountInfo = data.data.accountInfo[0];

        const zimbraFeatureAdminPreferencesEnabled = accountInfo.a.filter(
          a => a.n === "zimbraFeatureAdminPreferencesEnabled"
        )[0]._content;

        const zimbraMailQuota = accountInfo.a.filter(
          a => a.n === "zimbraMailQuota"
        )[0]._content;
        const zimbraMailAttachmentMaxSize = accountInfo.a.filter(
          a => a.n === "zimbraMailAttachmentMaxSize"
        )[0]._content;

        const zimbraAccountStatus = accountInfo.a.filter(
          a => a.n === "zimbraAccountStatus"
        )[0]._content;

        // 20211205201624.074Z
        const zimbraCreateTimestamp = accountInfo.a.filter(
          a => a.n === "zimbraCreateTimestamp"
        )[0]._content;
        setCreateTime(
          zimbraCreateTimestamp.substr(0, 4) +
            "/" +
            zimbraCreateTimestamp.substr(4, 2) +
            "/" +
            zimbraCreateTimestamp.substr(6, 2) +
            " " +
            zimbraCreateTimestamp.substr(8, 2) +
            ":" +
            zimbraCreateTimestamp.substr(10, 2) +
            ":" +
            zimbraCreateTimestamp.substr(12, 2)
        );

        let zimbraLastLogonTimestamp = "";
        try {
          zimbraLastLogonTimestamp = accountInfo.a.filter(
            a => a.n === "zimbraLastLogonTimestamp"
          )[0]._content;
          setLastLogonTime(
            zimbraLastLogonTimestamp.substr(0, 4) +
              "/" +
              zimbraLastLogonTimestamp.substr(4, 2) +
              "/" +
              zimbraLastLogonTimestamp.substr(6, 2) +
              " " +
              zimbraLastLogonTimestamp.substr(8, 2) +
              ":" +
              zimbraLastLogonTimestamp.substr(10, 2) +
              ":" +
              zimbraLastLogonTimestamp.substr(12, 2)
          );
        } catch (err) {}

        console.log("zimbraMailQuota", zimbraMailQuota);
        console.log("zimbraMailAttachmentMaxSize", zimbraMailAttachmentMaxSize);
        console.log("zimbraAccountStatus", zimbraAccountStatus);
        console.log("zimbraLastLogonTimestamp", zimbraLastLogonTimestamp);
        console.log("zimbraCreateTimestamp", zimbraCreateTimestamp);

        setZimbraMailQuota(parseInt(zimbraMailQuota, 10) / 1024 / 1024);
        setZimbraAccountStatus(zimbraAccountStatus);
        setZimbraMailAttachmentMaxSize(
          parseInt(zimbraMailAttachmentMaxSize, 10) / 1024 / 1024
        );

        if (parseInt(zimbraMailQuota, 10) === 0) setEnableMailQuota("FALSE");
        else setEnableMailQuota("TRUE");

        if (parseInt(zimbraMailAttachmentMaxSize, 10) === 0)
          setEnableMaxSendAttachSize("FALSE");
        else setEnableMaxSendAttachSize("TRUE");
      }
    })
    .catch(error => {
      console.log(error)
    })
  };

  const makeParams = () => {
    let params = [
      { name: "zimbraAccountStatus", value: zimbraAccountStatus },
      {
        name: "zimbraFeatureAdminPreferencesEnabled",
        value: zimbraFeatureAdminPreferencesEnabled
      },
      {
        name: "zimbraMailAttachmentMaxSize",
        value:
          enableMaxSendAttachSize === "TRUE"
            ? parseInt(zimbraMailAttachmentMaxSize, 10) * 1024 * 1024
            : 0
      },
      {
        name: "zimbraMailQuota",
        value:
          zimbraMailQuota === "TRUE"
            ? parseInt(zimbraMailQuota, 10) * 1024 * 1024
            : 0
      }
    ];

    return params;
  };
  const modifyDistributionInfo = () => {
    let params = makeParams();

    console.log("modifyDistributionInfo", params);

    modifyDistribution(data.userData.id, groupName, params).then(result => {
      console.log(result);
      data.onApply();
    })
    .catch(error => {
      console.log(error)
    })
  };

  // const createDistributionInfo = () => {
  //   let params = makeParams();

  //   console.log("createDistributionInfo", params);
  //   createDistribution(groupName, groupEmail + "@brainary.io", params).then(
  //     result => {
  //       data.onApply();
  //     }
  //   );
  // };

  const _createModifyGroupInfo = () => {
    var groupEmail2 = null;

    if (groupEmail != null) {
      groupEmail2 =
        groupEmail.indexOf("@") >= 0 ? groupEmail : groupEmail + "@brainary.io";
    }

    let pwd = null;
    if (tempPassword !== "" && tempPassword != null) pwd = tempPassword;


    createModifyGroup(
      data.mode === "MODIFY" ? data.userData.groupCode : null,
      groupName,
      groupEmail2,
      data.mode === "MODIFY"
        ? data.userData.parentGroupCode : data.groupCode,
      data.mode === "MODIFY"
        ? data.userData.groupLevel
        : parseInt(data.groupLevel) + 1 + "",
      quotaType,
      pwd,
      parseInt(zimbraMailQuota, 10) * 1024 * 1024, // mailQuota,
      parseInt(zimbraMailAttachmentMaxSize, 10) * 1024 * 1024, // maxAttachSize
      memberList,
      deletedList
    ).then(result => {
      console.log(result);
      data.onApply(groupEmail2);
    })
    .catch(error => {
      console.log(error)
    })
  };

  const createModifyGroupInfo = () => {
    console.log("createModifyGroupInfo", hasEmail, memberList, deletedList);

    if (
      (data.mode !== "MODIFY" && groupEmail.trim() !== "") ||
      (!hasEmail && groupEmail.trim() !== "")
    ) {
      console.log("createDistribution");

      createDistribution(
        groupName,
        groupEmail.indexOf("@") >= 0 ? groupEmail : groupEmail + "@brainary.io",
        []
      ).then(result => {
        console.log("createDistribution", result);

        if (result.code === 200) {
          _createModifyGroupInfo();
        } else toast("이미 존재하는 메일 아이디 입니다.");
      })
      .catch(error => {
        console.log(error)
      })
    } else {
      _createModifyGroupInfo();
    }
  };

  const checkSavable = () => {
    // && groupEmail?.length > 0

    const bPassword = data.mode === 'MODIFY' || (data.mode === 'NEW' && checkPassword());
    const bQuota =
      enableMailQuota === "FALSE" ||
      (enableMailQuota === "TRUE" && parseInt(zimbraMailQuota, 10) >= 10);

    const bAttach =
      enableMaxSendAttachSize === "FALSE" ||
      (enableMaxSendAttachSize === "TRUE" &&
        parseInt(zimbraMailAttachmentMaxSize, 10) >= 1);

    return bPassword && bQuota && bAttach && groupName?.length > 0; // && memberList?.length > 0;
  };

  const pollGroupList = () => {
    getGroupListData().then(result => {
      console.log("getGroupListData", result);

      const groupData = result.data.groups.filter(
        group => group.groupCode === data.userData?.groupCode
      );

      console.log("GROUP DATA", data.userData?.groupCode, groupData);

      if (groupData != null && groupData.length > 0) {
        setGroupName(groupData[0].groupName);
        setGroupEmail(groupData[0].groupEmail);
        setPassword(groupData[0].password);
        setQuotaType(groupData[0].quotaType);
        setZimbraMailQuota(groupData[0].mailQuota || 10);
        setZimbraMailAttachmentMaxSize(groupData[0].maxAttachSize || 1);

        if (groupData[0].groupEmail == null || groupData[0].groupEmail === "")
          setHasEmail(false);
        else setHasEmail(true);

        setRefresh(!refresh);
      } else toast("그룹정보 조회중 에러가 발생했습니다.");
    });
  };

  useEffect(() => {
    console.log("GroupEdit", data);

    // data.userData.groupCode: "6c087d54-d884-435f-886f-765824716ad0"
    // data.userData.groupLevel: "4"
    // data.userData.parentGroupCode: "A01.D1707"

    // setGroupName(data.userData?.groupName);
    // setGroupEmail(data.userData?.groupEmail);
    // setPassword(data.userData?.password || "12345678");
    // setQuotaType(data.userData?.quotaType || "G");
    // setZimbraMailQuota(data.userData?.mailQuota || 10);
    // setZimbraMailAttachmentMaxSize(data.userData?.maxAttachSize || 1);

    setRefresh(!refresh);

    if (data.mode === "MODIFY") {
      const list = [];

      pollGroupList();

      data.userData.memberList.forEach(member => {
        list.push({
          isAnonymous: member.isAnonymous,
          name: member.name,
          _content: member.email,
          zimbraId: member.zimbraId
        });
      });
      setMemberList(list);
    } else setMemberList([]);

    // if (data.mode === "MODIFY") getAccountInfo(data.userData.dlEmail);
  }, []);

  const checkPassword = () => {
    return (
      tempPassword.length >= 8 &&
      tempPassword1.length >= 8 &&
      tempPassword === tempPassword1
    );
  };


  useEffect(() => {}, [refresh, zimbraAccountStatus, zimbraMailQuota]);

  return (
    <>
      <DialogTitle id="alert-dialog-title" style={{ paddingBottom: "0px" }}>
        {data.mode === "NEW" ? "그룹 추가" : "그룹 수정"}
      </DialogTitle>
      <DialogContent
        style={{
          height: "480px"
        }}
      >
        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>대표아이디</div>

          {data.mode === "NEW" ? (
            <input
              type="text"
              value={groupEmail}
              className={Styles.popInputLongStyle}
              onChange={e => {
                setGroupEmail(e.target.value);
              }}
            />
          ) : (
            <input
              type="text"
              disabled={hasEmail}
              value={groupEmail}
              className={Styles.popInputLongStyle}
              onChange={e => {
                setGroupEmail(e.target.value);
              }}
            />
          )}
        </div>

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>
            그룹명<span style={{ color: "red" }}>*</span>
          </div>
          <input
            type="text"
            // disabled={data.mode === "MODIFY"}
            value={groupName}
            className={Styles.popInputLongStyle}
            onChange={e => {
              setGroupName(e.target.value);
            }}
          />
        </div>

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>비밀번호<span style={{ color: "red" }}>*</span></div>
          <Button
            className={Styles.buttonSmallStyle}
            style={{ height: "21px" }}
            onClick={() => {
              setShowChangePassword(true);
            }}
          >
            변경
          </Button>
        </div>

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>구성원</div>
          <div
            style={{
              display: "inline-block",
              paddingRight: "12px"
            }}
          >
            {memberList == null ? 0 : memberList.length} 명
          </div>
          <Button
            className={Styles.buttonSmallStyle}
            style={{ height: "21px" }}
            onClick={() => {
              // setShowGroup(false);
              setShowOrgList(true);
            }}
          >
            {data.mode === "NEW" ? "선택" : "변경"}
          </Button>
        </div>

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>그룹 상태</div>

          <RadioGroup
            label="사용함"
            name="gender1"
            style={{
              display: "inline-block",
              fontSize: "1.2rem",
              height: "34px",
              marginTop: "-7px"
            }}
            value={zimbraAccountStatus}
            onChange={handleChangeStatus}
          >
            <FormControlLabel
              value="active"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="활성"
            />
            <FormControlLabel
              value="maintenance"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="비활성"
            />
          </RadioGroup>
        </div>

        {data.mode === "MODIFY" && (
          <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
            <div className={Styles.popLabelStyle}>사용량</div>
            <span style={{ fontWeight: "bold" }}>메일</span>{" "}
            {/* {data.userData.mailQuota} */}
            {/* | <span style={{ fontWeight: "bold" }}>파일함</span> 1.35MB / 무제한(
          -%) */}
          </div>
        )}

        <div
          className={Styles.subTitlePopStyle}
          style={{ height: "24px", marginTop: "8px" }}
        >
          <div className={Styles.popLabelStyle}>
            용량 제한
            {/* <span style={{ color: "red" }}> *</span> */}
          </div>

          <RadioGroup
            label="사용함"
            name="gender1"
            style={{
              display: "inline-block",
              fontSize: "1.2rem",
              height: "34px",
              marginTop: "-7px"
            }}
            value={quotaType}
            onChange={handleChangeUsage}
          >
            <FormControlLabel
              value="G"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="그룹권한"
            />
            <FormControlLabel
              value="P"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="개인권한 적용"
            />
          </RadioGroup>
        </div>

        {quotaType === "G" && (
          <>
            <div
              className={Styles.dataRowStyle}
              style={{
                borderTop: "1px solid #c8cace",
                height: "34px",
                lineHeight: "34px",
                paddingLeft: "5px"
              }}
            >
              <div className={[Styles.popLabelStyle]}>메일함 저장공간</div>
              <div
                className={[Styles.dataColStyle]}
                style={{
                  borderLeft: "1px solid #c8cace",
                  height: "34px",
                  textAlign: "left",
                  paddingLeft: "12px",
                  width: "276px"
                }}
              >
                <RadioGroup
                  label="사용함"
                  name="gender1"
                  style={{
                    display: "inline-block",
                    fontSize: "1.2rem",
                    height: "34px",
                    marginTop: "-7px"
                  }}
                  value={enableMailQuota}
                  onChange={handleChangeMailQuota}
                >
                  <FormControlLabel
                    value="TRUE"
                    style={{
                      marginTop: "4px",
                      marginRight: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Radio />}
                    label=""
                  />
                  <input
                    type="text"
                    value={zimbraMailQuota}
                    placeholder="10M 이상"
                    style={{ marginLeft: "-14px" }}
                    className={Styles.popInputSmallStyle}
                    onChange={e => {
                      setZimbraMailQuota(e.target.value);
                    }}
                  />{" "}
                  MB
                  <FormControlLabel
                    value="FALSE"
                    style={{
                      marginTop: "4px",
                      marginLeft: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Radio />}
                    label="무제한"
                  />
                </RadioGroup>
              </div>
            </div>

            <div
              className={Styles.dataRowStyle}
              style={{ height: "34px", lineHeight: "34px", paddingLeft: "5px" }}
            >
              <div className={[Styles.popLabelStyle]}>
                송신메일 첨부 크기 제한
              </div>
              <div
                className={[Styles.dataColStyle]}
                style={{
                  borderLeft: "1px solid #c8cace",
                  height: "34px",
                  textAlign: "left",
                  paddingLeft: "12px",
                  width: "276px"
                }}
              >
                <RadioGroup
                  label="사용함"
                  name="gender1"
                  style={{
                    display: "inline-block",
                    fontSize: "1.2rem",
                    height: "34px",
                    marginTop: "-7px"
                  }}
                  value={enableMaxSendAttachSize}
                  onChange={handleChangeMaxSendAttachSize}
                >
                  <FormControlLabel
                    value="TRUE"
                    style={{
                      marginTop: "4px",
                      marginRight: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Radio />}
                    label=""
                  />
                  <input
                    type="text"
                    placeholder="1M 이상"
                    value={zimbraMailAttachmentMaxSize}
                    style={{ marginLeft: "-14px" }}
                    className={Styles.popInputSmallStyle}
                    onChange={e => {
                      setZimbraMailAttachmentMaxSize(e.target.value);
                    }}
                  />{" "}
                  MB
                  <FormControlLabel
                    value="FALSE"
                    style={{
                      marginTop: "4px",
                      marginLeft: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Radio />}
                    label="무제한"
                  />
                </RadioGroup>
              </div>
            </div>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            paddingBottom: "8px"
          }}
        >
          <Button
            className={Styles.buttonSmallStyle}
            onClick={() => {
              // setShowAccount(false);
              data.onCancel();
            }}
          >
            취소
          </Button>
          <Button
            className={[
              Styles.buttonSmallStyle
              //   !checkIpAddress() && Styles.buttonDisableStyle
            ]}
            style={{
              marginLeft: "24px",
              background: `${!checkSavable() ? "#d5cce8" : "unset"}`
            }}
            autoFocus
            onClick={() => {
              // setShowAccount(false);
              // data.onApply();

              if (!checkSavable()) return;

              if (data.mode === "MODIFY") createModifyGroupInfo();
              else createModifyGroupInfo();
            }}
          >
            저장
          </Button>
        </div>
      </DialogActions>

      <Dialog
        open={showOrgList}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div
          style={{
            width: "840px",
            minWidth: "840px!important"
          }}
        >
          <SelectUser
            // onClick={dept => setTempDeptName(dept.deptName)}

            mode={data.mode}
            userData={memberList}
            onCancel={() => setShowOrgList(false)}
            onApply={(members, deletedList) => {
              setShowOrgList(false);

              console.log("NEW GROUP MEMBERS", members, deletedList);
              // handleOrgDeptSelected(selectedDept);
              setMemberList(members);
              setDeletedList(deletedList);
              setRefresh(!refresh);
            }}
          />
        </div>
      </Dialog>

      
      <Dialog
        open={showChangePassword}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">비밀번호 설정</DialogTitle>
        <DialogContent>
          <div>
            <input
              type="password"
              placeholder="비밀번호 (8자 이상)"
              value={tempPassword}
              className={Styles.popInputLongStyle}
              onChange={e => {
                console.log("PASSWORD", e.target.value);
                setTempPassword(e.target.value);
              }}
            ></input>
          </div>
          <div style={{marginTop: "12px"}}>
            <input
              type="password"
              placeholder="비밀번호 확인 (8자 이상)"
              value={tempPassword1}
              className={Styles.popInputLongStyle}
              onChange={e => {
                console.log("PASSWORD1", e.target.value);
                setTempPassword1(e.target.value);
              }}
            ></input>
          </div>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              paddingTop: "16px",
              paddingBottom: "8px"
            }}
          >
            <Button
              className={Styles.buttonSmallStyle}
              onClick={() => {
                setTempPassword("");
                setTempPassword1("");
                setShowChangePassword(false);
              }}
            >
              취소
            </Button>
            <Button
              className={[
                Styles.buttonSmallStyle
                // !checkIpAddress() && Styles.buttonDisableStyle
              ]}
              style={{
                marginLeft: "24px",
                background: `${!checkPassword() ? "#d5cce8" : "unset"}`
              }}
              autoFocus
              onClick={() => {
                // handlePressSave();
                if(!checkPassword()) {
                  toast('비밀번호를 확인해 주세요.')
                  return;
                }

                setShowChangePassword(false);
              }}
            >
              확인
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
